import { TimeHandler } from "./time-handler";
export class VoiceAssistant extends TimeHandler {

    private messages: { id: string; obtainText: () => string }[];
    private currentMessageIndex: number;
    private messageContainer: HTMLElement;

    constructor(messages?: { id: string; obtainText: () => string }[]) {

        super('time-outs')

        this.messages = messages ?? [];
        this.currentMessageIndex = 0;
        let container = document.getElementById('voice-assistant-messages')
        if (!container) container = this.createMessageContainer();
        this.messageContainer = container
    }

    private createMessageContainer() {
        const container = document.createElement("dialog");
        container.id = "voice-assistant-messages";
        container.setAttribute('aria-live','assertive')
        container.setAttribute('aria-role','alert')
        container.setAttribute('open','true')
        container.setAttribute('tab-index','-1')
        document.body.prepend(container);
        return container;
    }

    public addMessage(id: string, obtainText: () => string): void {
        this.messages.push({ id, obtainText });
    }

    public deleteMessage(id: string): void {
        this.messages = this.messages.filter((message) => message.id !== id);
        // Adjust currentMessageIndex if needed
        if (this.messages[this.currentMessageIndex]?.id !== id) return;
        this.currentMessageIndex = Math.max(0, Math.min(this.currentMessageIndex, this.messages.length - 1));
    }

    public next(): void {
        if (this.messages.length === 0) return;
        this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
        this.updateMessageDisplay();
    }

    public previous(): void {
        if (this.messages.length === 0) return;
        this.currentMessageIndex =
            (this.currentMessageIndex - 1 + this.messages.length) % this.messages.length;
        this.updateMessageDisplay();
    }

    public goTo(id: string): void {
        const index = this.messages.findIndex((message) => message.id === id);
        if (index !== -1) {
            this.currentMessageIndex = index;
            this.updateMessageDisplay();
        }
    }

    public speak (message: string): void {
        // return
        this.messageContainer.innerHTML = message
        // this.messageContainer.ariaLabel = message;
        // this.messageContainer.focus();
    }

    private updateMessageDisplay(): void {
        if (this.messages.length > 0) {
            const text = this.messages[this.currentMessageIndex].obtainText();
            this.speak(text)
        }
    }
}